import * as React from "react";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  text?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = "md", 
  className = "",
  text = "Loading..."
}) => {
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-8 h-8", 
    lg: "w-12 h-12"
  };

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div className={`${sizeClasses[size]} border-2 border-tertiary border-t-accent rounded-full animate-spin`}></div>
      {text && (
        <p className="mt-2 text-secondary text-sm">{text}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;
